// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

import { SEAT_MAP } from '../../products';
import { isSeatPreferenceSegment } from './segmentUtils';
const isSeatMapSellSpecification = spec => typeof spec === 'object' && spec !== null && 'sellSeatMapBounds' in spec;
const getSegmentIndex = segmentId => {
  if (segmentId.length === 2) {
    return segmentId[1];
  }
  return segmentId;
};
const getSegmentDefaultTravelerIds = segment => {
  if (isSeatPreferenceSegment(segment)) {
    return [0];
  }
  return [];
};
const transformSellSpecificationSegment = sellSpecificationSegment => sellSpecificationSegment && {
  ...sellSpecificationSegment,
  travelerIds: sellSpecificationSegment.travelerIds ? sellSpecificationSegment.travelerIds.map(Number) : getSegmentDefaultTravelerIds(sellSpecificationSegment)
};
const transformDeck = deck => ({
  ...deck,
  cabins: (deck.cabins || []).map(cabin => ({
    ...cabin,
    rows: cabin === null || cabin === void 0 ? void 0 : cabin.rows.map(row => ({
      ...row,
      sellSeatMapSeats: ((row === null || row === void 0 ? void 0 : row.sellSeatMapSeats) || []).map(seat => {
        var _seat$price, _seat$price2;
        return {
          ...seat,
          markup: seat === null || seat === void 0 || (_seat$price = seat.price) === null || _seat$price === void 0 || (_seat$price = _seat$price.markup) === null || _seat$price === void 0 ? void 0 : _seat$price.value,
          price: seat === null || seat === void 0 || (_seat$price2 = seat.price) === null || _seat$price2 === void 0 ? void 0 : _seat$price2.price.value
        };
      })
    }))
  }))
});
export const transformSeatmapPrices = (bounds = []) => bounds.map(bound => ({
  ...bound,
  sellSeatMapSegments: bound.sellSeatMapSegments.map(segment => {
    if (segment && 'lowerDeck' in segment && 'mainDeck' in segment && 'upperDeck' in segment) {
      return {
        ...segment,
        lowerDeck: transformDeck((segment === null || segment === void 0 ? void 0 : segment.lowerDeck) || {}),
        mainDeck: transformDeck((segment === null || segment === void 0 ? void 0 : segment.mainDeck) || {}),
        upperDeck: transformDeck((segment === null || segment === void 0 ? void 0 : segment.upperDeck) || {})
      };
    }
    return segment;
  })
}));
const getBounds = ({
  bounds,
  sellSpecification
}) => bounds.map(({
  boundId,
  segments = []
}) => {
  const sellSpecificationBound = sellSpecification === null || sellSpecification === void 0 ? void 0 : sellSpecification.sellSeatMapBounds.find(sellBound => (sellBound === null || sellBound === void 0 ? void 0 : sellBound.id) === boundId);
  const tripSegments = segments.filter(segment => segment.__typename === 'TripSegment');
  return {
    ...sellSpecificationBound,
    boundIndex: Number(boundId),
    boundName: {
      from: {
        city: tripSegments[0].origin.cityName
      },
      to: {
        city: tripSegments[tripSegments.length - 1].destination.cityName
      }
    },
    sellSeatMapSegments: tripSegments.map(segment => {
      var _segment$ticketingCar, _segment$marketingCar, _segment$ticketingCar2, _segment$marketingCar2;
      const sellSpecificationSegment = sellSpecificationBound ? sellSpecificationBound.sellSeatMapSegments.find(sellSegment => (sellSegment === null || sellSegment === void 0 ? void 0 : sellSegment.id) === segment.segmentId) : undefined;
      const segmentIndex = Number(getSegmentIndex(segment.segmentId));
      return {
        ...transformSellSpecificationSegment(sellSpecificationSegment),
        boundSegmentIndex: `${boundId}-${segmentIndex}`,
        segmentIndex,
        carrier: {
          code: ((_segment$ticketingCar = segment.ticketingCarrier) === null || _segment$ticketingCar === void 0 ? void 0 : _segment$ticketingCar.code) || ((_segment$marketingCar = segment.marketingCarrier) === null || _segment$marketingCar === void 0 ? void 0 : _segment$marketingCar.code),
          name: ((_segment$ticketingCar2 = segment.ticketingCarrier) === null || _segment$ticketingCar2 === void 0 ? void 0 : _segment$ticketingCar2.name) || ((_segment$marketingCar2 = segment.marketingCarrier) === null || _segment$marketingCar2 === void 0 ? void 0 : _segment$marketingCar2.name)
        },
        from: {
          city: segment.origin.cityName,
          iata: segment.origin.code
        },
        to: {
          city: segment.destination.cityName,
          iata: segment.destination.code
        }
      };
    })
  };
});
const getBoundsForPostbooking = ({
  availableExtraProducts,
  bounds
}) => {
  const seatMapProduct = availableExtraProducts.find(({
    id
  }) => Number(id) === SEAT_MAP.id);
  if (!isSeatMapSellSpecification(seatMapProduct === null || seatMapProduct === void 0 ? void 0 : seatMapProduct.sellSpecification)) {
    return [];
  }
  const sellSpecification = {
    ...seatMapProduct.sellSpecification,
    sellSeatMapBounds: transformSeatmapPrices(seatMapProduct.sellSpecification.sellSeatMapBounds)
  };
  return getBounds({
    bounds,
    sellSpecification
  });
};
export const getData = ({
  availableExtraProducts,
  bounds,
  sellSpecification
}) => {
  if (availableExtraProducts !== null && availableExtraProducts !== void 0 && availableExtraProducts.length) {
    return getBoundsForPostbooking({
      availableExtraProducts,
      bounds
    });
  }
  return getBounds({
    bounds,
    sellSpecification
  });
};
//# sourceMappingURL=seatMapTransformer.js.map